import PropTypes from "prop-types";

import Header from "components/Page/components/Header";
import PagePresenter from "presenters/PagePresenter";
import PageModules from "components/PageModules";
import RichTextFooter from "components/RichTextFooter";
import Categories from "components/Categories";

const Content = ({ page, isLoading }) => {
  const footer = PagePresenter.footer(page);
  const modules = PagePresenter.pageModules(page);

  return (
    <>
      <Header page={page} loading={isLoading} />
      <PageModules modules={modules} loading={isLoading} context={PagePresenter.context(page)}>
        <RichTextFooter richText={footer} />
        <Categories isDescriptionVisible={false} />
      </PageModules>
    </>
  );
};

Content.propTypes = {
  page: PagePresenter.shape(),
  isLoading: PropTypes.bool,
};

export default Content;
